import React from "react";

import SignUpForm from "src/domains/auth/components/SignUpForm";

import { Layout } from "./Layout";

/**
 * Register Page
 * Displays the signup form for new user registration
 */
export const RegisterPage: React.FC = () => {
  return <Layout Component={SignUpForm} />;
};

export default RegisterPage;
